import customInputStyle from './customInputStyle';

const customSelectStyle = {
  ...customInputStyle,
}

export default customSelectStyle;
